"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerComponent = ContainerComponent;
const React = __importStar(require("react"));
const property_1 = require("@genesys/property");
const GenesysPropertiesSelector = __importStar(require("@genesys/client-core/lib/genesys-properties-selector"));
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const Actions = __importStar(require("./actions"));
function ContainerComponent(props) {
    const airInDef = airInDefinition(property_1.PropertyValueSet.getAmount("temperature", props.airIn), property_1.PropertyValueSet.getAmount("pressure", props.airIn));
    const airOutDef = airOutDefinition();
    const powerDef = powerDefinition();
    const onAirInChange = (pvs) => props.dispatch(Actions.setPropertiesAirIn(pvs));
    const onAirOutChange = (pvs) => props.dispatch(Actions.setPropertiesAirOut(pvs));
    const onPowerChange = (pvs) => props.dispatch(Actions.setPropertiesPower(pvs));
    const onCalculatePower = () => props.dispatch(Actions.calculatePower());
    const onCalculateAirOut = () => props.dispatch(Actions.calculateAirOut());
    return (React.createElement(Elements.FlexContainerRowWithPadding, { center: false },
        React.createElement(Elements.InnerContainer, null,
            React.createElement(Elements.H3, null, "Air in"),
            React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { selectedProperties: props.airIn, productProperties: airInDef, screenAmountProfileFieldGroup: "AirPower", onChange: (pvs) => onAirInChange(pvs), uniqueId: "airpower_airin" })),
        React.createElement(Elements.InnerContainer, null,
            React.createElement(Elements.InnerContainer, null,
                React.createElement(Elements.StandardButton, { onClick: () => onCalculateAirOut() }, "Calculate air out")),
            React.createElement(Elements.InnerContainer, null,
                React.createElement(Elements.StandardButton, { onClick: () => onCalculatePower() }, "Calculate power"))),
        React.createElement(Elements.InnerContainer, null,
            React.createElement(Elements.H3, null, "Air out"),
            React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { selectedProperties: props.airOut, productProperties: airOutDef, screenAmountProfileFieldGroup: "AirPower", onChange: (pvs) => onAirOutChange(pvs), uniqueId: "airpower_airout" }),
            React.createElement(GenesysPropertiesSelector.PropertiesSelectorContainer, { selectedProperties: props.power, productProperties: powerDef, screenAmountProfileFieldGroup: "AirPower", onChange: (pvs) => onPowerChange(pvs), uniqueId: "airpower_power" }))));
}
function airInDefinition(temperature, pressure) {
    return [
        {
            sort_no: 1,
            name: "temperature",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 2,
            name: "humidity",
            group: "",
            quantity: "HumidityRatio",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            conversionParameters: {
                temperature: temperature,
                pressure: pressure
            },
            value: []
        },
        {
            sort_no: 3,
            name: "flow",
            group: "",
            quantity: "MassFlow",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 4,
            name: "pressure",
            group: "",
            quantity: "Pressure",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
function airOutDefinition() {
    return [
        {
            sort_no: 1,
            name: "temperature",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 2,
            name: "humidity",
            group: "",
            quantity: "HumidityRatio",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
function powerDefinition() {
    return [
        {
            sort_no: 1,
            name: "power",
            group: "",
            quantity: "Power",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
//# sourceMappingURL=container-component.js.map